export default __webpack_public_path__ + "static/media/325C8E41-1120-4A41-9D76-7326DFFB1F8A_1_102_o.f43e3f1f.jpeg";